import ModalDialog from '@ui/modal/ModalDialog';
import Tooltip from '@ui/tooltip/Tooltip';
import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BAA } from '@utils/constants';
import BookAnAppointmentForm from './BookAnAppointmentForm';
import LoginOrRegisterColumn from '@components/login/LoginOrRegisterColumn';
const BookAnAppointmentMbm = (props) => {
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);
    const [storesAvailables, setStoresAvailables] = useState([]);
    const [selectedStore, setSelectedStore] = useState();
    const [storeFilter, setStoreFilter] = useState([]);
    const [loggedIn, setLoggedIn] = useState(window.loggedin);
    const storesContainer = useRef();
    useEffect(() => {
        console.info('load available stores for MBM BAA');
        api.bookAnAppointmentStores(window.country, '861860000', BAA.APPOINTMENT.INSTORE).then((data) => {
            let arr = [...storeFilter];
            arr = data.stores.map((e) => e.code);
            setStoreFilter(arr);
        });
        api.searchStoresWithPersonalization().then((data) => setStoresAvailables(data));
    }, []);
    // controlled from outside
    useEffect(() => {
        setShowOverlay(props.show);
    }, [props.show]);
    const storeFiltered = useMemo(() => {
        const storesFilterArray = storesAvailables.filter((store) => storeFilter.includes(store.ID));
        return [...new Set(storesFilterArray.map((store) => store))];
    }, [storesAvailables, storeFilter]);
    return (React.createElement(React.Fragment, null,
        props.show == undefined && (React.createElement("button", { type: "button", className: `button ${props.ctaPrimary ? 'button--primary' : 'button--link button--arrow-right'}`, onClick: () => {
                var _a;
                setShowOverlay(true);
                if (props.onButtonClick) {
                    props.onButtonClick();
                }
                else {
                    analytics.bookAnAppointment((_a = props.product) === null || _a === void 0 ? void 0 : _a.masterId);
                }
            } },
            React.createElement("span", null, t('storelocator.bookAnAppointment')))),
        React.createElement(ModalDialog, { id: "mbm-baa", hideHeader: true, noPadding: true, isOpen: showOverlay, className: "bookanappointment mbm-modal", contentLabel: t('bookanappointment.title'), onRequestClose: () => {
                if (props.show != undefined) {
                    props.onClose();
                }
                else {
                    setShowOverlay(false);
                }
            } },
            React.createElement("div", { className: 'bookanappointment__body' },
                React.createElement("div", { className: "bookanappointment__left", style: { backgroundImage: `url(${props.modalimage})` } }),
                React.createElement("div", { className: "bookanappointment__right" },
                    React.createElement("h1", { className: "dialog__title" }, t('bookanappointment.title')),
                    React.createElement("div", { className: "container-body-bookanappointiment" }, loggedIn ? (React.createElement(React.Fragment, null, !selectedStore ? (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "bookanappointment-mbm__desc primary-xs" }, t('mbm.baa')),
                        storeFiltered.length > 0 ? (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "bookanappointment-mbm__descstores primary-xs" }, t('mbm.availablestores')),
                            React.createElement("ul", { ref: storesContainer, className: "bookanappointment-mbm__stores" }, storeFiltered.map((store, i) => (React.createElement("li", { key: i },
                                React.createElement("button", { onClick: () => setSelectedStore(store), className: "bookanappointment-mbm__store" },
                                    React.createElement("span", null, store.countryCode.displayValue),
                                    React.createElement("p", null, store.name)),
                                React.createElement("div", { className: "store-features" },
                                    store.storeServices.personalizationRoom && (React.createElement("div", { className: "store-feature" },
                                        t('storelocator.personalizationRoom'),
                                        React.createElement(Tooltip, { id: store.ID + '_garment', icon: "info", text: t('storelocator.personalizationroom.tooltip'), containerRef: storesContainer }))),
                                    store.storeServices.personalizationRoom && store.storeServices.GarmentKit && React.createElement("span", null, "|"),
                                    store.storeServices.GarmentKit && (React.createElement("div", { className: "store-feature" },
                                        t('storelocator.GarmentKit'),
                                        React.createElement(Tooltip, { id: store.ID + '_garment', icon: "info", text: t('storelocator.garmentkit.tooltip'), containerRef: storesContainer })))))))))) : (React.createElement("span", { className: "primary-xxs" }, t('mbm.notavailablestores'))))) : (React.createElement(React.Fragment, null,
                        React.createElement(BookAnAppointmentForm, { type: "mbm", recipeid: props.recipeid, size: props.size, store: selectedStore, onArrowBack: () => setSelectedStore(undefined), product: props.product, paletteName: props.paletteName, addToWishlist: props.addToWishlist, fromContinueInStore: props.fromContinueInStore, manageappointmenturl: props.manageappointmenturl }))))) : (React.createElement(LoginOrRegisterColumn, { reloadComponent: true, reloadPage: true, privacypolicy: window.privacypolicyurl || props.privacypolicy, forgotpasswordform: window.forgotpasswordform || props.forgotpasswordform, closeModal: () => props.onClose, updateLoggeedStatus: () => setLoggedIn(true), updateLoggedin: () => setLoggedIn(true) }))))))));
};
export default BookAnAppointmentMbm;
